import {Locale} from '../../../provider/locale/localization';
import {useModal} from '../../../provider/modal/modal-hook';
import {useUser} from '../../../provider/user/user-hook';

export function useRemoveFromFavoritesModal(): (path: string, childPath: Array<string>) => void {
    const {modal} = useModal();
    const {removeFavorite} = useUser();

    return (path: string, childPaths: Array<string>) => {
        modal.confirm({
            title: <Locale stringKey="NAVIGATION__REMOVE_FROM_FAVORITES__TITLE" />,
            content: <Locale stringKey="NAVIGATION__REMOVE_FROM_FAVORITES__DESCRIPTION" />,
            cancelText: <Locale stringKey="POPUP__BUTTON__CANCEL" />,
            okText: <Locale stringKey="NAVIGATION__REMOVE_FROM_FAVORITES__REMOVE_BUTTON" />,
            onOk: () => {
                return removeFavorite(path, childPaths);
            },
        });
    };
}
